<panel width="auto" maxWidth="650">
  <div class="row">
    <div class="col title">
        <tooltip [text]="company.name">
            <h1 class="full-overflow-hidden">{{ company.name }}</h1>
        </tooltip>
    </div>
    <div class="col-auto icons">
      <icon type="users" [trigger-soft-popup]="showContact" />
      <soft-popup #showContact [width]="300">
        @for (companyContact of company.companyContacts; track companyContact) {
          <contact-card [showPhone]="true" [showEmail]="true" [contact]="companyContact.contact" />
        }
      </soft-popup>
    </div>
  </div>
</panel>
